import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface NotificationParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface NotificationType{
    id?:number;
    name:string;
    actionNeeded:string;
    activeFlag:string;
    parameters?: NotificationParameter[];
    links?: any;
}

export interface PushNotification{
    id?:number;
    type:string;
    tenantId:any;
    branchId?:any;
    title:string;
    message:string;
    confirmFlag:string;
    createdAt:Date;
    createdBy:number;
    sentAt:Date;
    readAt:Date;
    readBy:number;
    scheduleAt:Date;
}


export abstract class NotificationData {
    abstract list(url: string): Observable<any>;
    abstract create(url: string, data: any): Observable<any>;
    abstract update(url: string, data: any): Observable<any>;
    abstract delete(url: string): Observable<any>;
}
